import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Agli baar render hone par fallback UI dikhane ke liye state update karein
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Error ko state mein save karein taake screen par dikha sakein
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("Error pakda gaya:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Agar error aata hai toh yeh screen dikhegi (White screen nahi aayegi)
      return (
        <div style={{ padding: '30px', backgroundColor: '#ffe6e6', color: '#990000', minHeight: '100vh', fontFamily: 'sans-serif', direction: 'ltr' }}>
          <h2>Oops! App Crash Ho Gayi 🚨</h2>
          <p>Neeche error ki details likhi hain, isko dekh kar hum problem theek kar sakte hain:</p>
          
          <div style={{ background: '#fff', padding: '15px', border: '1px solid #cc0000', borderRadius: '8px', overflowX: 'auto' }}>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              <summary style={{ fontWeight: 'bold', cursor: 'pointer', fontSize: '1.2rem' }}>Error Detail Dekhne Ke Liye Yahan Click Karein</summary>
              <br />
              <strong style={{fontSize: '1.1rem'}}>{this.state.error && this.state.error.toString()}</strong>
              <br />
              <span style={{ color: '#555' }}>
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </span>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;